"use strict";
exports.__esModule = true;
exports.SvgPriority3 = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgPriority3 = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "#007CC5", fillRule: "nonzero", d: "M6.892 1.507c-.39.049-.697.357-.697.74v7.738l-2.33-2.103-.076-.06a.855.855 0 00-1.045.06.711.711 0 000 1.072l3.695 3.337.076.06a.858.858 0 001.045-.06l3.696-3.337.067-.068a.713.713 0 00-.067-1.004l-.076-.06-.101-.06a.854.854 0 00-.944.12L7.802 9.985l.002-7.737-.006-.087C7.74 1.771 7.398 1.5 7 1.5l-.108.007z" }),
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" })))); };
//# sourceMappingURL=Priority3.js.map